(() => {
  'use strict';

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  let localeStrings = {};
  try { localeStrings = JSON.parse(document.getElementById('QDSLocaleStrings')?.textContent || '{}'); } catch (_) {}
  const rootRoute = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const money = (cents) => {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-CA', {
        style: 'currency', currency
      }).format(Number(cents) / 100);
    } catch (_) {
      return `${(Number(cents) / 100).toFixed(2)} $`;
    }
  };

  const setBodyLock = () => {
    const openLayer = $('[data-mobile-menu]:not([hidden]), [data-search-drawer]:not([hidden]), [data-gallery-lightbox][open]');
    document.body.classList.toggle('is-locked', Boolean(openLayer));
  };

  const mobileMenu = $('[data-mobile-menu]');
  const menuToggle = $('[data-menu-toggle]');
  const closeMenu = () => {
    if (!mobileMenu) return;
    mobileMenu.hidden = true;
    menuToggle?.setAttribute('aria-expanded', 'false');
    setBodyLock();
    menuToggle?.focus();
  };
  menuToggle?.addEventListener('click', () => {
    mobileMenu.hidden = false;
    menuToggle.setAttribute('aria-expanded', 'true');
    setBodyLock();
    $('[data-menu-close]', mobileMenu)?.focus();
  });
  $$('[data-menu-close]', mobileMenu || document).forEach((button) => button.addEventListener('click', closeMenu));
  mobileMenu?.addEventListener('click', (event) => {
    if (event.target === mobileMenu) closeMenu();
    if (event.target.closest('a')) closeMenu();
  });

  const searchDrawer = $('[data-search-drawer]');
  const searchOpen = $('[data-search-open]');
  const closeSearch = () => {
    if (!searchDrawer) return;
    searchDrawer.hidden = true;
    searchOpen?.setAttribute('aria-expanded', 'false');
    setBodyLock();
    searchOpen?.focus();
  };
  searchOpen?.addEventListener('click', () => {
    searchDrawer.hidden = false;
    searchOpen.setAttribute('aria-expanded', 'true');
    setBodyLock();
    setTimeout(() => $('input[type="search"]', searchDrawer)?.focus(), 40);
  });
  $$('[data-search-close]').forEach((button) => button.addEventListener('click', closeSearch));

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (searchDrawer && !searchDrawer.hidden) closeSearch();
    if (mobileMenu && !mobileMenu.hidden) closeMenu();
  });

  $$('[data-predictive-search]').forEach((form) => {
    const input = $('input[type="search"]', form);
    const results = $('[data-predictive-results]', form);
    const endpoint = form.dataset.predictiveUrl;
    if (!input || !results || !endpoint) return;
    let timer;
    let controller;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const term = input.value.trim();
      if (term.length < 2) {
        results.innerHTML = '';
        return;
      }
      timer = setTimeout(async () => {
        controller?.abort();
        controller = new AbortController();
        results.setAttribute('aria-busy', 'true');
        try {
          const url = `${endpoint}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('Search unavailable');
          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          results.innerHTML = $('#shopify-section-predictive-search', parsed)?.innerHTML || '';
        } catch (error) {
          if (error.name !== 'AbortError') results.innerHTML = '';
        } finally {
          results.removeAttribute('aria-busy');
        }
      }, 220);
    });
  });

  $$('[data-quantity-selector]').forEach((selector) => {
    const input = $('input', selector);
    $('[data-quantity-minus]', selector)?.addEventListener('click', () => {
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
    });
    $('[data-quantity-plus]', selector)?.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
    });
  });

  $$('[data-product-gallery]').forEach((gallery) => {
    const main = $('[data-gallery-main]', gallery);
    const lightbox = $('[data-gallery-lightbox]', gallery);
    const viewport = $('[data-lightbox-viewport]', lightbox);
    const zoomValue = $('[data-zoom-value]', lightbox);
    let lightboxImage = $('[data-lightbox-image]', lightbox);
    let zoom = 1;

    const updateZoom = (nextZoom) => {
      zoom = Math.min(4, Math.max(1, nextZoom));
      if (!lightboxImage || !zoomValue) return;
      lightboxImage.style.width = zoom > 1 ? `${zoom * 100}%` : '';
      lightboxImage.classList.toggle('is-zoomed', zoom > 1);
      viewport?.classList.toggle('is-zoomed', zoom > 1);
      zoomValue.textContent = `${Math.round(zoom * 100)}%`;
      if (zoom === 1 && viewport) {
        viewport.scrollTop = 0;
        viewport.scrollLeft = 0;
      }
    };

    const openLightbox = (trigger) => {
      if (!lightbox || !viewport) return;
      if (!lightboxImage) {
        lightboxImage = document.createElement('img');
        lightboxImage.className = 'product-gallery__lightbox-image';
        lightboxImage.dataset.lightboxImage = '';
        viewport.append(lightboxImage);
      }
      lightboxImage.src = trigger.dataset.zoomSrc || '';
      lightboxImage.alt = trigger.dataset.zoomAlt || '';
      updateZoom(1);
      if (typeof lightbox.showModal === 'function') lightbox.showModal();
      else lightbox.setAttribute('open', '');
      setBodyLock();
      $('[data-lightbox-close]', lightbox)?.focus();
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      if (typeof lightbox.close === 'function') lightbox.close();
      else lightbox.removeAttribute('open');
      setBodyLock();
    };

    $$('[data-media-id]', gallery).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const template = $('[data-media-template]', thumb);
        if (!template || !main) return;
        main.innerHTML = template.innerHTML;
        $$('[data-media-id]', gallery).forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
      });
    });

    gallery.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-gallery-open]');
      if (trigger && gallery.contains(trigger)) openLightbox(trigger);
    });
    $('[data-lightbox-close]', lightbox)?.addEventListener('click', closeLightbox);
    $('[data-zoom-in]', lightbox)?.addEventListener('click', () => updateZoom(zoom + 0.5));
    $('[data-zoom-out]', lightbox)?.addEventListener('click', () => updateZoom(zoom - 0.5));
    $('[data-zoom-reset]', lightbox)?.addEventListener('click', () => updateZoom(1));
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });
    lightbox?.addEventListener('close', setBodyLock);
  });

  $$('[data-product-section]').forEach((section) => {
    const variantsNode = $('[data-product-variants]', section);
    const select = $('[data-variant-select]', section);
    if (!variantsNode || !select) return;
    let variants = [];
    try { variants = JSON.parse(variantsNode.textContent); } catch (_) { return; }

    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === select.value);
      if (!variant) return;
      const price = $('[data-product-price]', section);
      const compare = $('[data-compare-price]', section);
      const sku = $('[data-product-sku]', section);
      const availability = $('[data-availability]', section);
      const addButton = $('[data-add-to-cart]', section);
      const addText = $('[data-add-to-cart-text]', section);
      const selectedOption = select.options[select.selectedIndex];

      if (price) price.textContent = selectedOption?.dataset.price || money(variant.price);
      if (compare) {
        const formattedCompare = selectedOption?.dataset.comparePrice || '';
        compare.hidden = !formattedCompare;
        compare.textContent = formattedCompare;
      }
      if (sku) sku.textContent = variant.sku || '—';
      if (availability) {
        availability.classList.toggle('is-available', variant.available);
        const availabilityMessages = JSON.parse($('[data-product-availability]', section)?.textContent || '{}');
        const availabilityText = $('[data-availability-text]', availability);
        if (availabilityText) availabilityText.textContent = availabilityMessages[String(variant.id)] || (variant.available ? localeStrings.availableToOrder : localeStrings.soldOut);
      }
      if (addButton) addButton.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? localeStrings.addToCart : localeStrings.soldOut;
      if (variant.featured_media?.id) {
        $(`[data-media-id="${variant.featured_media.id}"]`, section)?.click();
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });
  });

  const updateCartCount = async () => {
    const response = await fetch(`${rootRoute()}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    $$('[data-cart-count]').forEach((count) => {
      count.textContent = cart.item_count;
      count.hidden = cart.item_count === 0;
    });
  };

  const showToast = (message) => {
    const toast = $('[data-cart-toast]');
    if (!toast) return;
    const text = $('[data-cart-toast-text]', toast);
    if (text && message) text.textContent = message;
    toast.hidden = false;
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => { toast.hidden = true; }, 4500);
  };

  $$('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      const submitter = event.submitter;
      if (submitter && submitter.name && submitter.name !== 'add') return;
      event.preventDefault();
      const button = submitter || $('button[type="submit"]', form);
      const original = button?.textContent;
      if (button) {
        button.disabled = true;
        button.textContent = localeStrings.adding;
      }
      try {
        const response = await fetch(`${rootRoute()}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || localeStrings.cartError);
        await updateCartCount();
        showToast(localeStrings.cartAdded);
      } catch (error) {
        window.alert(error.message);
      } finally {
        if (button) {
          button.disabled = false;
          button.textContent = original;
        }
      }
    });
  });

  $$('[data-recommendations]').forEach(async (section) => {
    if (section.textContent.trim()) return;
    try {
      const response = await fetch(section.dataset.url);
      if (!response.ok) return;
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const replacement = $('[data-recommendations]', parsed);
      if (replacement?.innerHTML.trim()) section.innerHTML = replacement.innerHTML;
    } catch (_) { /* Recommendations are optional. */ }
  });

  $$('[data-auto-submit]').forEach((field) => field.addEventListener('change', () => field.form?.submit()));
  $('[data-filter-toggle]')?.addEventListener('click', (event) => {
    const facets = $('[data-facets]');
    if (!facets) return;
    const isOpen = facets.classList.toggle('is-open');
    event.currentTarget.setAttribute('aria-expanded', String(isOpen));
  });
  $$('[data-scroll-top]').forEach((link) => link.addEventListener('click', (event) => {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }));
})();

